var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "body" },
    [
      _c(
        "el-card",
        { attrs: { header: "附件图片列表" } },
        [
          _c(
            "el-row",
            [
              _c(
                "el-upload",
                {
                  ref: "problemProductPhotoRef",
                  class: { hide: true },
                  attrs: {
                    accept:
                      ".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP",
                    disabled: true,
                    multiple: "",
                    "list-type": "picture-card",
                    action: "upload",
                    "file-list": _vm.problemProductPhotoList,
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "file",
                      fn: function ({ file }) {
                        return _c("div", { staticStyle: { height: "100%" } }, [
                          _c("img", {
                            attrs: {
                              width: "100%",
                              height: "100%",
                              src: file.url,
                              alt: "",
                            },
                          }),
                          _c(
                            "span",
                            { staticClass: "el-upload-list__item-actions" },
                            [
                              _c(
                                "span",
                                {
                                  staticClass: "el-upload-list__item-preview",
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleProblemProductPreview(
                                        file
                                      )
                                    },
                                  },
                                },
                                [_c("i", { staticClass: "el-icon-zoom-in" })]
                              ),
                            ]
                          ),
                        ])
                      },
                    },
                  ]),
                },
                [_c("i", { staticClass: "el-icon-plus" })]
              ),
              _c(
                "el-dialog",
                {
                  staticClass: "enlargePhoto",
                  attrs: { visible: _vm.problemProductDialogVisible },
                  on: {
                    "update:visible": function ($event) {
                      _vm.problemProductDialogVisible = $event
                    },
                  },
                },
                [
                  _c("img", {
                    attrs: {
                      width: "100%",
                      src: _vm.problemProductImageUrl,
                      alt: "",
                    },
                  }),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }